/**
 * LuxPainter — 2D light mage silhouette (staff + orb).
 */
export const LuxPainter = {
  paint(ctx, _pos, radius, _entity) {
    ctx.beginPath();
    ctx.arc(0, 0, radius * 0.85, 0, Math.PI * 2);
    ctx.fillStyle = '#1e3a8a';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(0, -radius * 0.55, radius * 0.4, 0, Math.PI * 2);
    ctx.fillStyle = '#38bdf8';
    ctx.fill();

    ctx.fillStyle = '#e0f2fe';
    ctx.fillRect(radius * 0.55, -radius * 0.7, radius * 0.12, radius * 1.2);

    ctx.beginPath();
    ctx.arc(radius * 0.62, -radius * 0.85, radius * 0.22, 0, Math.PI * 2);
    ctx.fillStyle = '#7dd3fc';
    ctx.fill();
  }
};
